module.exports = __webpack_public_path__ + "static/media/intra_origin_transfer.02024dd9.svg";